import styled from "styled-components";
import colors from "../../designSystem/colors";
import sizing from "../../designSystem/sizing";

export const ModalWrapper = styled.div`
  background-color: ${colors.UI.BACKGROUND.STANDARD};
  border: 1px solid ${colors.UI.BACKGROUND.STANDARD};
  border-radius: ${sizing.RADIUS.MEDIUM};
  space-between: 12px;
  padding: 32px 28px 15px 28px;
  width: 500px;
  height: 350px;
`;

export const ModalTitle = styled.div`
  font-size: 30px;
  margin-bottom: 50px;
  text-align: center;
`;

export const InputRow = styled.div`
  margin-bottom: 24px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border-radius: 6px;
  border: 1px solid #ccc;
  outline: none;
  margin-bottom: 30px;
  box-sizing: border-box;
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  align-items: stretch;
  justify-content: space-between;
  margin-top: 12px;
  & > * {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  button,
  [role="button"] {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`;
